module.exports = __webpack_public_path__ + "static/media/liveroom-setting-zzb.3108bfa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-zzb.png
// module id = 2048
// module chunks = 6